import firebase from "firebase";

export enum StatoCompletamento {
    IN_CUCINA = 0,
    AL_PASS = 1,
    CONSEGNATO = 2
};

export default class OrdineStatoCompletamento {
    date: Date;
    stato: StatoCompletamento;


    constructor() {
        this.date = new Date();
        this.stato = StatoCompletamento.IN_CUCINA;
    }

    static convertFromFirestore(statoCompletamento: firebase.firestore.DocumentData): OrdineStatoCompletamento {
        let result: OrdineStatoCompletamento = new OrdineStatoCompletamento();
        result.date = (statoCompletamento.date as firebase.firestore.Timestamp).toDate();
        result.stato = statoCompletamento.stato as StatoCompletamento;
        return result;
    }

    static convertToFirestore(statoCompletamento: OrdineStatoCompletamento): firebase.firestore.DocumentData {
        let result: firebase.firestore.DocumentData = {};
        result.date = firebase.firestore.Timestamp.fromDate(statoCompletamento.date);
        result.stato = statoCompletamento.stato as number;
        return result;
    }
}